<template>
   
  
    <template v-if="isButtonLoading">
      <div class="infsc-button">
        <UiButton 
          :is-loading="isLoading" 
          :name="buttonName"
          :type="'primary wide outline'"
        />
      </div>
    </template>
    <template v-else>
      <div class="infsc">
        <i v-if="isLoading" class="gloading"></i>
      </div>
    </template>
  
</template>


<script setup lang="ts">

interface PageProps {
   isLoading: boolean,
   isButtonLoading?: boolean,
   buttonName?: string
}

const props = withDefaults(defineProps<PageProps>(), {
   isLoading: false,
   isButtonLoading: false
})
 
</script>
  

<style scoped>
  
.infsc{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 2rem;
  position: relative;
  min-height: 100px;
}
  
  
.infsc-button{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  margin-top: 1rem;
  position: relative;
  min-height: 60px;
  max-width: 300px;
}
.infsc-button:deep(.btn){
  text-transform: none;
}
  
</style>
